import { Badge, Group, Paper, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { OffenePunkteWidget } from "../components/OffenePunkteWidget.js";
import { useCustomers } from "../hooks/useCustomers.js";

/**
 * Verwaltung › Datenlücken: was bisher als Admin-Kachel auf der Startseite
 * stand (#361). Die offenen Punkte je Bereich und die Kunden ohne Service Lead.
 */
export function DatenlueckenPage() {
  const { t } = useTranslation();
  return (
    <Stack gap="md">
      <Title order={2}>{t("pages.datenluecken.title")}</Title>
      <Group align="stretch" gap="md">
        <OrphanCustomersWidget />
      </Group>
      <OffenePunkteWidget />
    </Stack>
  );
}

function OrphanCustomersWidget() {
  const { t } = useTranslation();
  const { data, isLoading } = useCustomers({ withoutLead: true, page: 1 });
  const count = data?.total ?? 0;
  return (
    <Paper
      component={Link}
      to="/customers"
      search={{ withoutLead: true } as never}
      p="md"
      withBorder
      style={{
        textDecoration: "none",
        color: "inherit",
        minWidth: 280,
        cursor: "pointer",
      }}
    >
      <Group justify="space-between" align="flex-start">
        <Stack gap={4}>
          <Text size="xs" c="dimmed" fw={600} tt="uppercase">
            {t("pages.datenluecken.orphanLabel")}
          </Text>
          <Text size="sm">{t("pages.datenluecken.orphanDescription")}</Text>
        </Stack>
        <ThemeIcon size="xl" radius="md" variant="light" color={count > 0 ? "orange" : "gray"}>
          <Text fw={700} size="lg">
            {isLoading ? "…" : count}
          </Text>
        </ThemeIcon>
      </Group>
      {count > 0 && (
        <Badge color="orange" variant="light" size="sm" mt="xs">
          {t("pages.datenluecken.orphanAction")}
        </Badge>
      )}
    </Paper>
  );
}
